<template>
  <app-table v-bind="$attrs" class="w-full">
    <template v-slot:table-body>
      <tr
        v-for="(item, index) in downloadTop"
        :key="index"
        class="border border-collapse border-dashed border-purple border-t-0 border-l-0 border-r-0 h-12"
      >
        <td width="20px">
          <approved-icn
            width="20px"
            height="20px"
            class="ml-2 mr-1"
          ></approved-icn>
        </td>
        <td width="200px">
          <span class="font-lg font-bold">{{ item.year }}年度</span>
          <span class="font-lg">｜{{ wereki(item.year) }}</span>
        </td>
        <td>
          <download-button-provider 
            :item="item" 
            :download="download" 
            :requireIdDownload="requireIdDownload"
          />
        </td>
      </tr>
    </template>
  </app-table>
</template>

<script>
import { reactive, onMounted } from 'vue'
import AppTable from '@/components/ui/AppTable'
import { useDownloads } from '@/services/useDownloads'

import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import DownloadButtonProvider from '@/components/provider/downloadButtonProvider/DownloadButtunProvider.vue'

export default {
  name: 'DownloadsTable',

  components: {
    AppTable,
    ApprovedIcn,
    DownloadButtonProvider,
  },

  setup() {
    const items = reactive([
      {
        id: 1,
        year: 2021,
        approved: false,
      },
      {
        id: 2,
        year: 2020,
        approved: true,
      },
      {
        id: 3,
        year: 2019,
        approved: true,
      },
    ])

    const wereki = year => {
      const opt = { year: 'numeric', month: 'long', day: 'numeric' }
      return (
        new Date(year, 1, 1)
          .toLocaleDateString('ja-JP-u-ca-japanese', opt)
          .split('年')[0] + '年度'
      )
    }
    const { getDownloadTop, downloadTop } = useDownloads()

    onMounted(async () => {
      await getDownloadTop()
    })

    return { downloadTop, items, wereki, DownloadButtonProvider, ...useDownloads() }
  },
}
</script>

<style lang="scss">
.download-button-table {
  width: 100%;
  :disabled {
    pointer-events: none;
  }
}
.download-button-table :hover svg.hover-white-icon {
  path {
    fill: #fff;
  }
}
button[disabled] {
  pointer-events: none;
}
</style>
